import React from 'react';
import cx from 'classnames';

const SectionLeft = ({ children }) => (
  <div className="left">
    { children }
  </div>
);

const SectionRight = ({ children, empty }) => (
  <div className={cx('right', empty && 'empty')}>
    { children }
  </div>
);

class Section extends React.Component {
  static Left = SectionLeft;

  static Right = SectionRight;

  render() {
    const { children, hidden } = this.props;
    const className = cx('flex-wrapper', hidden && 'hidden');
    return (
      <div className={className}>
        { children }
      </div>
    );
  }
}

export default Section;
